import { render } from "./solved_complaint_details.vue?vue&type=template&id=5efb0c20"
import script from "./solved_complaint_details.vue?vue&type=script&lang=js"
export * from "./solved_complaint_details.vue?vue&type=script&lang=js"

import "./solved_complaint_details.vue?vue&type=style&index=0&id=5efb0c20&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__